import { SERVICES_PROPERTIES } from 'app/config/services';
import notification from 'app/config/notification';

/**
 * Prepara o payload para a alteração de email.
 * @param {Object} values - Objeto contendo os valores necessários para a alteração de email.
 * @param {string|number} values.cdServico - Código do serviço.
 * @param {string} values.deEmail - Email atual.
 * @param {string} values.deNewEmail - Novo email.
 * @param {string} values.deMotivo - Novo email.
 * @param {Object} intl - Objeto que fornece acesso às mensagens internacionalizadas.
 * @returns {(Object|boolean)} O payload para a alteração de email, ou false se os emails forem iguais.
 */
export const setupChangeEmailPayload = ({ values, intl }) => {
    const initValue = SERVICES_PROPERTIES[values.cdServico]?.formInitialValues ?? {};
    const valuesCopy = { ...values, deNewEmail: values.deNewEmail.toLowerCase() };
    if (valuesCopy.deEmail && valuesCopy.deNewEmail === valuesCopy.deEmail) {
        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.EMAIL_IGUAL_SOLICITADO' }), {
            toastId: 'EMAIL_IGUAL_SOLICITADO',
            type: 'error',
        });
        return false;
    }
    return cleanup({ values: valuesCopy, validProperties: Object.keys(initValue) });
};

/**
 * Configura os valores iniciais para a alteração de email.
 * @param {Object} newRequest - Objeto contendo os dados da nova solicitação.
 * @param {string} newRequest.cdServico - Código do serviço.
 * @param {Object} newRequest.company - Objeto contendo os dados da empresa.
 * @param {Object} newRequest.user - Objeto contendo os dados do usuário.
 * @returns {Object} Um objeto contendo os valores iniciais configurados para a alteração de email.
 */
export const setupChangeEmailInitialValues = (newRequest) => {
    const initValue = SERVICES_PROPERTIES[newRequest.cdServico]?.formInitialValues ?? {};
    const endereco = newRequest?.company?.enderecoPessoa || newRequest?.company?.enderecoMatriz || {};

    const temp = {
        ...newRequest?.company,
        ...newRequest?.user,
        ...endereco,
        deNewEmail: initValue.deNewEmail ?? '',
        deMotivo: initValue.deMotivo ?? '',
        deObservacao: initValue.deObservacao ?? '',
    };
    if (newRequest?.company && Object.keys(newRequest.company).length > 0) {
        temp.deCpfCnpj =
            newRequest?.company?.deCpf || newRequest?.company?.deCpfCnpj || newRequest?.company?.deCnpjMatriz;
        temp.nmUsuario = newRequest?.company?.cdTipoPessoaFisica
            ? newRequest?.company?.nmCompleto || ''
            : newRequest?.company?.deRazaoSocial || '';
    }
    const valuesToCleanup = { ...initValue, ...temp, documentos: [] };
    return cleanup({ values: valuesToCleanup, validProperties: Object.keys(initValue) });
};

/**
 * Filtra um objeto com base em uma lista de propriedades válidas.
 * @param {Object} params - Parâmetros da função.
 * @param {Object} params.values - O objeto a ser filtrado.
 * @param {string[]} params.validProperties - Lista de propriedades válidas.
 * @returns {Object} Um novo objeto contendo apenas as propriedades válidas.
 */
const cleanup = ({ values, validProperties }) => {
    if (!values || !validProperties) return {};
    return Object.keys(values).reduce((result, key) => {
        if (validProperties.includes(key)) result[key] = values[key];
        return result;
    }, {});
};
